import { Button, ButtonGroup, Grid } from "@mui/material";
import { useState } from "react";
import AddPageWrapper from "../../components/general/AddPageWrapper";
import ReusableTextField from "../../components/general/ReusableTextField";
import TitleBar from "../../components/general/TitleBar";
import AnswerKey from "./AnswerKey";
import SectionSubmitRow from "./SectionSubmitRow";
import { createDefaultAnswer } from "./taskDefaults";
import { TASK_SECTION, isTaskSectionDirty } from "./taskSectionEdit";

const typeOptions = [
  { id: "mcq", name: "MCQ" },
  { id: "input", name: "Input" },
  { id: "open_ended", name: "Open Ended" },
];

const containerStyle = { paddingBottom: 20 };
const divStyle = { margin: 36, userSelect: "none", width: "100%" };
const topRowStyle = {
  display: "flex",
  flexWrap: "wrap",
  height: 180,
  alignItems: "flex-start",
};
const boxStyle = {
  border: "1px solid",
  borderRadius: 5,
  backgroundColor: "#F3F0F4",
  width: 240,
  height: 150,
  marginRight: 60,
  paddingInline: 12,
  paddingBottom: 10,
};
const typeBoxStyle = {
  ...boxStyle,
  width: "auto",
  height: "auto",
  minHeight: 150,
};
const correctAnswerBoxStyle = {
  ...boxStyle,
  minWidth: 320,
  flex: 1,
  maxWidth: 480,
};
const buttonGroupStyle = { paddingInline: 8, paddingBottom: 4 };
const titleRowStyle = { display: "flex", justifyContent: "space-around" };
const titleUnderlineStyle = { borderBottom: "1px solid" };
const normalStyle = { textTransform: "none", whiteSpace: "nowrap" };
const selectedStyle = {
  textTransform: "none",
  color: "#E83D4D",
  whiteSpace: "nowrap",
};
const correctAnswerFieldsStyle = {
  display: "flex",
  width: "100%",
  flexWrap: "wrap",
  gap: 12,
  alignItems: "center",
};

function formatLabel(target) {
  const label = target.replace("answer_", "");
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export default function AnswerSection({
  task,
  setTask,
  isReadOnly,
  original,
  isEdit,
  editAnswers,
  submittingSection,
  onSubmitSection,
}) {
  const [expand, setExpand] = useState(false);
  const { answer_type } = task;

  const updateAnswerType = (value) => {
    if (value === task.answer_type) return;
    const newTask = structuredClone(task);
    newTask.answer_type = value;
    newTask.answer_structure = value === "open_ended" ? "open" : "default";
    newTask.answer_layout = "vertical";
    newTask.answer_sorting = "fix";
    newTask.task_answers = [createDefaultAnswer()];
    setTask(newTask);
  };

  const applyInputCorrectAnswer = (index, target, value) => {
    const newTask = structuredClone(task);
    newTask.task_answers[index][target] = value;
    setTask(newTask);
  };

  const showAnswerKey =
    answer_type === "mcq" ||
    answer_type === "input" ||
    answer_type === "open_ended";
  const isInput = answer_type === "input";

  return (
    <Grid container style={containerStyle}>
      <TitleBar title="Answer Setting" state={expand} setState={setExpand} />
      {expand && (
        <AddPageWrapper>
          <div style={divStyle}>
            <div style={topRowStyle}>
              <div style={typeBoxStyle}>
                <div style={titleRowStyle}>
                  <h2 style={titleUnderlineStyle}>
                    {formatLabel("answer_type")}
                  </h2>
                </div>
                <ButtonGroup variant="outlined" style={buttonGroupStyle}>
                  {typeOptions.map(({ id, name }, i) => (
                    <Button
                      key={i}
                      style={
                        task.answer_type === id ? selectedStyle : normalStyle
                      }
                      onClick={() => !isReadOnly && updateAnswerType(id)}
                      disabled={isReadOnly}
                    >
                      {name}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>

              {isInput && (
                <div style={correctAnswerBoxStyle}>
                  <div style={titleRowStyle}>
                    <h2 style={titleUnderlineStyle}>Correct Answer</h2>
                  </div>
                  <div style={correctAnswerFieldsStyle}>
                    {task.task_answers.map((ans, index) => (
                      <ReusableTextField
                        width="100%"
                        key={index}
                        type="default"
                        fullWidth
                        label="Answer"
                        disabled={isReadOnly}
                        readOnly={isReadOnly}
                        placeholder={`Answer ${index + 1}`}
                        state={ans.answer}
                        setState={applyInputCorrectAnswer}
                        count={index}
                        target="answer"
                        onBlur
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
            {showAnswerKey && (
              <AnswerKey
                task={task}
                setTask={setTask}
                isReadOnly={isReadOnly}
              />
            )}
          </div>
          {isEdit && original && !isReadOnly && (
            <SectionSubmitRow
              disabled={
                !editAnswers ||
                !isTaskSectionDirty(original, task, TASK_SECTION.ANSWER) ||
                submittingSection !== null
              }
              submitting={submittingSection === TASK_SECTION.ANSWER}
              onSubmit={() => onSubmitSection(TASK_SECTION.ANSWER)}
            />
          )}
        </AddPageWrapper>
      )}
    </Grid>
  );
}
